import {Component, EventEmitter, OnInit} from '@angular/core';
import {ITooltipComponent} from "@shared/models/common.models";

@Component({
    standalone: false,
    selector: 'particle-form-field-error-popover',
  templateUrl: './form-field-error-popover.component.html',
  styleUrls: ['./form-field-error-popover.component.scss']
})
export class FormFieldErrorPopoverComponent implements OnInit, ITooltipComponent {
  inputMetadata: any;
  action: EventEmitter<any> = new EventEmitter<any>();
  error: string;
  constructor() { }

  ngOnInit() {
    this.action.emit({data: 'something'});
    this.error='Error occured in field'
  }

}
